/**
 * Deep links used by workflow emails: ?client=<clientId>[&workflowTask=<taskId>][&tab=<tabName>]
 * The app consumes the client/tab part once on load; the task part is picked
 * up by the client's workflow runs section once its tasks are live.
 */
const KEYS = ['client', 'workflowTask', 'tab'];

let pending = null;

/** Read and clear the deep-link params from the address bar (once). */
export function consumeWorkflowDeepLink() {
  if (pending !== null) return pending;
  if (typeof window === 'undefined') return (pending = {});
  const params = new URLSearchParams(window.location.search);
  const clientId = String(params.get('client') || '').trim();
  const out = clientId
    ? { clientId, taskId: String(params.get('workflowTask') || '').trim() || null, tab: String(params.get('tab') || '').trim() || null }
    : {};
  if (KEYS.some((k) => params.has(k))) {
    KEYS.forEach((k) => params.delete(k));
    const rest = params.toString();
    window.history.replaceState({}, document.title, `${window.location.pathname}${rest ? `?${rest}` : ''}${window.location.hash || ''}`);
  }
  pending = out;
  return pending;
}

/** The task a deep link asked to open, cleared once a section opens it. */
export function takePendingWorkflowTaskId(clientId) {
  const link = consumeWorkflowDeepLink();
  if (!link.taskId || link.clientId !== clientId) return null;
  const id = link.taskId;
  pending = { ...link, taskId: null };
  return id;
}

/** Build the same link (used by the tag catalogue's samples and tests). */
export function buildWorkflowDeepLink(origin, clientId, { taskId = null, tab = null } = {}) {
  const base = String(origin || '').replace(/\/+$/, '');
  const params = new URLSearchParams({ client: clientId });
  if (taskId) params.set('workflowTask', taskId);
  if (tab) params.set('tab', tab);
  return `${base}/?${params.toString()}`;
}
